import { render, staticRenderFns } from "./GripAnalysisCriteria.vue?vue&type=template&id=475d5f9b"
import script from "./GripAnalysisCriteria.vue?vue&type=script&lang=ts"
export * from "./GripAnalysisCriteria.vue?vue&type=script&lang=ts"
import style0 from "./GripAnalysisCriteria.vue?vue&type=style&index=0&id=475d5f9b&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports